import ChevronRight from "../../../../../assets/icons/icon-chevron-right.svg"
import { isStatusDto, StatusDto } from "../../../../../enums/Domain/Status"
import Pill from "../../../Pill"

interface ISidePanelHeader {
    descriptor: string,
    value: string,
    cantNavigate?: boolean | undefined,
    statuses: StatusDto | StatusDto[] | undefined,
    onClick: Function | undefined,
}

export default function SidePanelHeader({ descriptor, value, statuses, onClick, cantNavigate }: ISidePanelHeader) {
    return (
        <div className={`side-panel__title ${onClick ? "side-panel__title--can-click" : ""} `} onClick={onClick ? () => onClick() : undefined}>
            <p className="small margin__right--xxs">{descriptor}</p>
            <h2 className="margin__right--xs">{value}</h2>
            {statuses && isStatusDto(statuses) && <Pill statusDto={statuses} />}
            {statuses && Array.isArray(statuses) &&
                <div className="display--flex gap--xxs overflow--hidden">
                    {statuses.map(x => <Pill statusDto={x} />)}
                </div>
            }
            {!cantNavigate && onClick && <img className="margin__left--auto" src={ChevronRight} /> }
        </div>
    )
}